// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__2lKH4","list":"BalanceDue_list__12NRV","listRow":"BalanceDue_listRow__3eMIU","total":"BalanceDue_total__q_4if"};